module.exports = __webpack_public_path__ + "static/img/花瓶3.59b1c88.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/papercutLamp/imgs/花瓶3.png
// module id = kgda
// module chunks = 2